import axios from 'axios';
import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, ADMIN_LOADED, AUTH_FAIL, RESET_PERMISSIONS } from '../type/type';
import { removeToken, setAuthToken } from '../../utils/setAuthToken';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const PROXY = process.env.REACT_APP_API_URL + 'api/';

export const loadUser = () => async (dispatch) => {
  if (localStorage.tokenAdmin || sessionStorage.tokenAdmin) {
    setAuthToken(localStorage.tokenAdmin || sessionStorage.tokenAdmin)
  }

  try {
    const res = await axios.patch(PROXY + 'admin')
    dispatch({
      type: ADMIN_LOADED,
      payload: res.data,
    })
  } catch (error) {
    dispatch({
      type: AUTH_FAIL,
    })
  }
}

export const login = (userObj) => async (dispatch) => {
  try {
    const body = JSON.stringify(userObj);
    const res = await axios.post(`${PROXY}admin/login`, body, config);

    if (res?.data?.token) {

      if (userObj.rememberMe) {
        localStorage.setItem('tokenAdmin', res?.data?.token);
      } else {
        sessionStorage.setItem("tokenAdmin", res?.data?.token);
      }
      dispatch({ type: LOGIN_SUCCESS, payload: res.data });
      dispatch(loadUser());

      return res.data;
    } else {
      throw new Error(res?.data?.message || "Invalid response from server.");
    }
  } catch (error) {
    console.error('Login error:', error?.response || error?.message);

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong. Try again later.';

    dispatch({ type: LOGIN_FAIL, payload: errorMessage });

    return { error: true, message: errorMessage };
  }
};

export const logout = () => (dispatch) => {
  removeToken(); // Remove token from storage
  localStorage.removeItem('tokenAdmin'); // Ensure token is removed
  dispatch({
    type: RESET_PERMISSIONS, // Reset Redux state
  });
  dispatch({
    type: LOGOUT, // Reset Redux state
  });
};

export const updateAdmin = (id, updatedData) => async (dispatch) => {
  try {
    const response = await axios.put(`${PROXY}admin/${id}`, updatedData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const changePassword = (id, updatedData) => async (dispatch) => {
  try {
    const response = await axios.put(`${PROXY}admin/change-password/${id}`, updatedData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const forgotPasswordsendOtp = (data) => async (dispatch) => {
  const res = await axios.post(PROXY + "admin/forgot-password", data);
  return res;
};

export const verifyOtp = (data) => async (dispatch) => {
  const res = await axios.post(PROXY + "admin/verify-otp", data);
  return res;
};

export const resetPassword = (data) => async (dispatch) => {
  const res = await axios.post(PROXY + "admin/reset-password", data);
  return res;
};


